export default __webpack_public_path__ + "static/media/headerIconMail.958abc70.svg";